module.exports = __webpack_public_path__ + "media/images/pop-up-homepage-9c88e74c7e64ce2c3005333338e99583.jpg";